import React from "react";
import OverviewModule from "@/components/dataviz/OverviewModule";
import { StyledDetailList, StyledColumn } from "../../styled";
import { DescriptionText } from "../DescriptionText";
import { StageAccordion } from "../StageAccordion";

export const SummaryColumn = ({
  overviewData,
  overviewConfig,
  selectionDetails,
  stageData,
}) => (
  <StyledColumn>
    <OverviewModule
      loading={false}
      data={overviewData}
      dataPointsConfig={overviewConfig}
      textAlign="left"
    />
    <StyledDetailList>
      <DescriptionText>Templates: {selectionDetails.templatesLabel}</DescriptionText>
      <DescriptionText>Scopes: {selectionDetails.scopesLabel}</DescriptionText>
      <DescriptionText>{selectionDetails.annotationSummary}</DescriptionText>
      <DescriptionText>Tenant mode: {overviewData.meta.tenantMode}</DescriptionText>
    </StyledDetailList>
    {stageData
      .filter((stage) => !stage.hidden)
      .map((stage) => (
        <StageAccordion key={stage.id} stage={stage} />
      ))}
  </StyledColumn>
);


